<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table ref="table" pagination :max-items="itemsPerPage" search :data="listCompanies">
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<div class="flex flex-wrap-reverse items-center data-list-btn-container">
					<!-- ACTION - DROPDOWN -->
				</div>
				<!-- ITEMS PER PAGE -->
				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
					<div
						class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
					>
						<span class="mr-2"
							>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
							{{
								listCompanies.length - currentPage * itemsPerPage > 0
									? currentPage * itemsPerPage
									: listCompanies.length
							}}
							of {{ queriedItems }}</span
						>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>
					<vs-dropdown-menu>
						<vs-dropdown-item @click="itemsPerPage = 4">
							<span>4</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 15">
							<span>15</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 20">
							<span>20</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="category">{{ $t("DesignConfig.TypeConfigConfigName") }}</vs-th>
				<vs-th sort-key="name">{{ $t("DesignConfig.TypeConfigStatus") }}</vs-th>
				<vs-th sort-key="name">{{ $t("DesignConfig.TypeConfigAddDateOn") }}</vs-th>

				<vs-th v-if="typeConfigUpdatePermission || typeConfigDeletePermission">{{
					$t("MODULE_PERMISSION.Action")
				}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="product-name font-medium truncate">{{ tr.name }}</p>
						</vs-td>

						<vs-td>
							<p class="product-category">{{ statusName(tr.status_id) }}</p>
						</vs-td>

						<vs-td>
							<p class="product-category">{{ tr.added_on }}</p>
						</vs-td>

						<vs-td
							class="whitespace-no-wrap"
							v-if="typeConfigUpdatePermission || typeConfigDeletePermission"
						>
							<feather-icon
								v-if="typeConfigUpdatePermission"
								icon="EditIcon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								@click.stop="editData(tr)"
							/>

							<feather-icon
								v-if="typeConfigDeletePermission"
								icon="TrashIcon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2"
								@click.stop="openConfirm(tr.id)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleTypeConfigCrud from "@/store/type-config-crud/moduleTypeConfigCrud.js";
import moduleCommon from "@/store/common/moduleCommon.js";

export default {
	name: "TypeConfigCrudListView",
	data() {
		return {
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
		};
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		// Consulta los tipos de configuraciones encontrados en el estate
		listCompanies() {
			return this.$store.state.moduleTypeConfigCrud.config_list;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listCompanies.length;
		},
		typeConfigUpdatePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_U");
		},
		typeConfigDeletePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_D");
		},
		companyStatus() {
			return this.$store.state.moduleCommon.status;
		},
		statusName() {
			return function (id) {
				return this.$store.state.moduleCommon.status.find((statu) => statu.id === id).name;
			};
		},
	},
	methods: {
		// Pregunta si desea eliminar el tipo seleccionado
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DesignConfig.DeleteTypeConf"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Confirma la eliminación del tipo
		acceptAlert() {
			//alert(this.itemSelected)
			this.deleteData(this.itemSelected);
		},
		// Elimina el tipo
		deleteData(id) {
			this.$vs.loading();
			this.$store
				.dispatch("moduleTypeConfigCrud/removeTypeConfig", id)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigDelete"),
						text: this.$t("TextConfirmCompanyConfigDelete"),
					});
					this.$vs.loading.close();
				})
				.catch((err) => {
					console.error(err);
				});
		},
		// Click en la edicion
		editData(data) {
			this.$emit("selectedCompanyEmit", data);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async getActiveStatusCode() {
			try {
				const response = await this.$store.dispatch("moduleCommon/fetchStatusData");
				if (response.status !== 200) {
					throw new Error(response.status);
				}
			} catch (error) {}
		},
	},
	created() {
		// Registra modulo
		if (!moduleTypeConfigCrud.isRegistered) {
			this.$store.registerModule("moduleTypeConfigCrud", moduleTypeConfigCrud);
			moduleTypeConfigCrud.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		this.getActiveStatusCode();
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
